(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  var root = document.querySelector('.sp-story');
  if (!root || window.__spPreorderTracking) return;
  window.__spPreorderTracking = true;

  var TEMPLATE = (document.body.className.match(/template-suffix-([a-z0-9-]+)/) || [, 'unknown'])[1];
  var queue = [];
  var consent = null; // null = unknown, true/false once the API answers

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }

  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }

  function send(name, props) {
    props = props || {};
    props.template = TEMPLATE;
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;            // refused: drop, never queue
    if (queue.length < 60) queue.push([name, props]);
  }

  function settle() {
    var a = allowed();
    if (a === null) return;                   // still unknown, wait for the consent event
    consent = a;
    if (a) { queue.forEach(function (q) { deliver(q[0], q[1]); }); }
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  // --- which beat an element sits in (a stable label, taken from the section's own eyebrow/heading)
  function beatOf(el) {
    var beat = el.closest('.sp-story__beat');
    if (!beat) return 'story';
    if (beat.__spName) return beat.__spName;
    var h = beat.querySelector('.sp-story__eyebrow, h2, .sp-story__h2');
    beat.__spName = h ? h.textContent.trim().slice(0, 48) : 'story';
    return beat.__spName;
  }

  send('sp_preorder_view');

  // --- scroll depth, once per threshold
  var depths = [25, 50, 75, 100], hit = {}, maxDepth = 0;
  function onScroll() {
    var doc = document.documentElement;
    var seen = window.scrollY + window.innerHeight;
    var pct = Math.min(100, Math.round((seen / doc.scrollHeight) * 100));
    if (pct > maxDepth) maxDepth = pct;
    depths.forEach(function (d) {
      if (pct >= d && !hit[d]) { hit[d] = 1; send('sp_preorder_scroll', { depth: d }); }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // --- which beats are actually reached
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        send('sp_preorder_beat_seen', { beat: beatOf(e.target) });
      });
    }, { threshold: 0.35 });
    root.querySelectorAll('.sp-story__beat').forEach(function (b) { io.observe(b); });
  }

  // --- photo opens, slide arrows, FAQ opens (one delegated listener)
  root.addEventListener('click', function (ev) {
    var pic = ev.target.closest('[data-zoom-src]');
    if (pic) {
      send('sp_preorder_photo_open', { beat: beatOf(pic), title: (pic.getAttribute('data-zoom-title') || '').slice(0, 48) });
      return;
    }
    var arrow = ev.target.closest('[data-slide]');
    if (arrow) send('sp_preorder_slide', { beat: beatOf(arrow), dir: arrow.getAttribute('data-slide') === '1' ? 'next' : 'prev' });
  }, true);

  root.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var pic = ev.target.closest && ev.target.closest('[data-zoom-src]');
    if (pic) send('sp_preorder_photo_open', { beat: beatOf(pic), title: (pic.getAttribute('data-zoom-title') || '').slice(0, 48) });
  }, true);

  root.querySelectorAll('details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var q = d.querySelector('summary');
      send('sp_preorder_faq_open', { beat: beatOf(d), question: q ? q.textContent.trim().slice(0, 64) : '' });
    });
  });

  // --- the buy button: how far down, and how long in, the decision was made
  var started = Date.now();
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('form[action*="/cart/add"] button[type="submit"], .sp-preorder-cta, .product-form button[type="submit"]');
    if (btn) send('sp_preorder_cta_click', { depth: maxDepth, seconds: Math.round((Date.now() - started) / 1000) });
  }, true);

  // --- engaged time (visible only, capped so a forgotten tab cannot inflate it)
  var visible = 0, since = document.visibilityState === 'visible' ? Date.now() : 0, sent = false;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { since = Date.now(); }
    else if (since) { visible += Date.now() - since; since = 0; }
  });
  function leave() {
    if (sent) return; sent = true;
    if (since) visible += Date.now() - since;
    send('sp_preorder_engaged', { seconds: Math.min(1800, Math.round(visible / 1000)), depth: maxDepth });
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); });
})();
